module.exports = __webpack_public_path__ + "static/hoops-40aeafc379587b8a44d93e5c33d403a6.jpg";